// mdi icon docs:
// https://cdn.materialdesignicons.com/5.1.45/
// https://pictogrammers.github.io/@mdi/font/5.1.45/
// https://pictogrammers.github.io/@mdi/font/5.1.45/

import {
  mdiHandshake,
  mdiMedicalBag,
  mdiPharmacy,
  mdiFolderOpen,
  mdiViewList,
  mdiAccountCircle,
  mdiAccountGroup,
  mdiAccountCog,
  mdiHumanHandsup,
  mdiFormatLineSpacing,
} from "@mdi/js";

const Menu = [
  {
    text: "Partner Management",
    name: "partner",
    icon: mdiHandshake,
  },
  {
    text: "Insurance Management",
    name: "insurance",
    icon: mdiMedicalBag,
    // item.isAllowed is used to prevent menu which is not available in external dashboard menu to be forbidden
    isAllowed: true,
    group: "insurance",
    isMainDashboard: true,
    items: [
      {
        text: "Insurer List",
        name: "insurer",
        icon: mdiPharmacy,
      },
      {
        text: "Product Category List",
        name: "product-category",
        icon: mdiFolderOpen,
      },
      {
        text: "Product List",
        name: "product",
        icon: mdiViewList,
      },
    ],
  },
  {
    text: "Access Management",
    name: "access-management",
    icon: mdiAccountCircle,
    group: "access-management",
    items: [
      {
        text: "User List",
        name: "user",
        icon: mdiAccountGroup,
      },
      {
        text: "Role List",
        name: "role",
        icon: mdiAccountCog,
      },
      {
        text: "Privilege List",
        name: "privilege",
        icon: mdiHumanHandsup,
      },
    ],
  },
  {
    text: "Customise Navigation",
    action: "customiseNavigation",
    icon: mdiFormatLineSpacing,
  },
];

export default Menu;
